import firebase from "firebase";
import platform from "platform";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

firebase.initializeApp(firebaseConfig);

export const getToken = () => {
  if (platform.name !== "IE" && platform.name !== "Safari") {
    const messaging = firebase.messaging();
    return messaging
      .getToken({
        vapidKey:
          "BLpzcNGqYcNAEZAQV9o_vm1Z4rHCKbPG0omIo8fVBytgRl-o57yapjVXbznEiYFKNg664Oa0KRqyxCdhllf9e5w",
      })
      .then((currentToken) => {
        if (currentToken) {
          localStorage.setItem("fcmAdminToken", currentToken);
        } else {
          console.log(
            "No registration token available. Request permission to generate one."
          );
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      });
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (platform.name !== "IE" && platform.name !== "Safari") {
      const messaging = firebase.messaging();
      messaging.onMessage((payload) => {
        resolve(payload);
      });
    }
  });

export default firebase;